module.exports = __webpack_public_path__ + "static/media/bitz_logo_light.190993fa.svg";